import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaRadio from './VaRadio.vue'

export default withConfigTransport(VaRadio)
